import React from "react";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaWhatsapp } from "react-icons/fa";
import { navy } from "../../assets/data/colors";

const social = [
    {
        icon: <FaFacebookF />,
        label: "Facebook",
        handle: "@mehe.sherzad",
        link: "https://www.facebook.com/mehe.sherzad",
        color: "#1877F2",
        bg: "#EBF3FF",
    },
    {
        icon: <FaInstagram />,
        label: "Instagram",
        handle: "@dr.mohammad_sherzad",
        link: "https://www.instagram.com/dr.mohammad_sherzad",
        color: "#E1306C",
        bg: "#FFF0F5",
    },
    {
        icon: <FaTwitter />,
        label: "Twitter / X",
        handle: "@meheZebari",
        link: "https://twitter.com/meheZebari",
        color: "#1DA1F2",
        bg: "#EBF8FF",
    },
    {
        icon: <FaYoutube />,
        label: "YouTube",
        handle: "Light Channel",
        link: "https://www.youtube.com/channel/UCmxgLQBzODENCiQWNj_bpdQ",
        color: "#FF0000",
        bg: "#FFF0F0",
    },
    {
        icon: <FaWhatsapp />,
        label: "WhatsApp",
        handle: "+964 750 807 8879",
        link: "https://wa.me/07508078879",
        color: "#25D366",
        bg: "#EDFFF4",
    },
];

const SocialUs = () => {
    return (
        <div className="w-full">
            <div className="mb-6">
                <p style={{color: navy}} className="text-xs font-semibold tracking-[2.5px] uppercase mb-1">Find Us Online</p>
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Connect on social media</h3>
                <p className="text-sm text-gray-400 font-light mt-1">Reach out through any of these platforms.</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {social.map((item) => (
                    <a key={item.link} href={item.link} target="_blank" rel="noreferrer" className="group flex items-center gap-4 p-4 rounded-xl border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800/40 hover:border-gray-300 dark:hover:border-gray-600 hover:-translate-y-0.5 transition-all duration-200">
                        <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform duration-200 group-hover:scale-110" style={{ background: item.bg }}>
                            {item.icon}
                        </div>
                        <div className="min-w-0">
                            <p className="text-sm font-semibold text-gray-900 dark:text-white">{item.label}</p>
                            <p className="text-xs text-gray-400 font-light truncate">{item.handle}</p>
                        </div>
                        <svg
                            className="ml-auto w-4 h-4 text-gray-300 group-hover:text-gray-500 dark:group-hover:text-gray-400 flex-shrink-0 transition-colors"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={1.5}
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                        </svg>
                    </a>
                ))}
            </div>
        </div>
    );
};
export default SocialUs;